/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ProjectSearchResponse,
  SearchProjectsParams,
} from './platformapi.schemas';

import searchProjectsMutator from '../custom-axios-instance';

/**
 * Fetch list of projects with pagination, sorting and filtering applied. Returns the list as well as the total count of projects matching the filter criteria.
 * @summary Search Projects
 */
export const searchProjects = (params?: SearchProjectsParams, signal?: AbortSignal) => {
  return searchProjectsMutator<ProjectSearchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/search/projects/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchProjectsQueryKey = (params?: SearchProjectsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/search/projects/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProjects>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchProjects>>> = ({ signal }) =>
    searchProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof searchProjects>>>;
export type SearchProjectsQueryError = void | HTTPValidationError;

export function useSearchProjects<
  TData = Awaited<ReturnType<typeof searchProjects>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | SearchProjectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchProjects>>,
          TError,
          Awaited<ReturnType<typeof searchProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchProjects<
  TData = Awaited<ReturnType<typeof searchProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchProjects>>,
          TError,
          Awaited<ReturnType<typeof searchProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchProjects<
  TData = Awaited<ReturnType<typeof searchProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProjects>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search Projects
 */

export function useSearchProjects<
  TData = Awaited<ReturnType<typeof searchProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProjects>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
